import SkinlessPopover from './SkinlessPopover';

export default SkinlessPopover;
